<template>
  <div
    class="relative h-full flex flex-col"
    :class="usePurchaseFlowNav ? 'bg-bg-canvas' : 'bg-cascade-header'"
    :style="containerStyle"
  >
    <div v-if="!isMaintenanceMode && isAuthenticatedRoute" class="fixed top-0 z-20 w-full">
      <TopNavigation v-if="!usePurchaseFlowNav" />
      <PurchaseFlowTopNavigation v-else />
    </div>

    <main
      :class="[
        { '!pt-0': !isAuthenticatedRoute || isMaintenanceMode },
        { 'max-w-[1180px]': isAuthenticatedRoute && !isMaintenanceMode },
        usePurchaseFlowNav ? 'pt-[60px] lg:pt-18' : 'pt-[60px] lg:pt-[88px]',
      ]"
      class="mx-auto relative flex-1 w-full px-3 maxconent:px-0"
    >
      <div
        class="pointer-events-none fixed top-[90px] left-1/2 z-[100] w-full max-w-[1180px] -translate-x-1/2 px-3 maxconent:px-0 lg:top-[124px]"
      >
        <div class="pointer-events-auto ml-auto flex w-fit flex-col gap-2">
          <Notification
            v-for="alert in UIStore.alert_list"
            :key="alert.id"
            :alert="alert"
            @close-alert="UIStore.removeNotification(alert.id)"
          />
        </div>
      </div>

      <router-view v-if="!isAuthenticatedRoute || dataStore.is_app_initialized" />
      <LoadingSpinner v-else :show="UIStore.is_loading" />
    </main>

    <!-- <div
      v-if="isAuthenticatedRoute && !route.fullPath.includes('select-offering')"
      ref="disclaimerRef"
      class="p-4 md:mb-0 md:p-10 font-inter text-xs font-medium text-light mb-30"
      :class="usePurchaseFlowNav ? 'mb-29' : 'mb-15'"
    >
      <div class="mb-2 uppercase font-bold">Important Disclosures</div>
      <div>
        Phoenix Energy One, LLC (“Phoenix Energy”) is conducting offerings of debt securities
        pursuant to (i) an exemption from registration provided by Rule 506(c) of Regulation D (the
        “Private Placement Offering”) of the Securities Act of 1933, as amended (the “Act”) and (ii)
        a registration statement on Form S-1 under the Act (including a prospectus) filed with the
        Securities and Exchange Commission (the “SEC”) (the “Registered Offering”). In addition,
        Adamantium Capital, a wholly owned financing subsidiary of Phoenix Energy, is conducting an
        offering of debt securities pursuant to Rule 506(c) of Regulation D of the Act (the
        “Adamantium Offering”) and loans the proceeds of such offering to Phoenix Energy as its
        sponsor. The debt securities are offered through registered broker dealer(s) that are
        members of FINRA/ SIPC (<a
          class="font-inter text-xxs font-medium text-blue-600"
          href="https://www.finra.org/"
          target="_blank"
          rel="noopener noreferrer"
          >finra.org</a
        >/<a
          href="https://www.sipc.org/"
          target="_blank"
          rel="noopener noreferrer"
          class="font-inter text-xxs font-medium text-blue-600"
          >sipic.org</a
        >), that are not affiliated with Phoenix Energy, although certain non-executive personnel of
        Phoenix Energy are registered representatives of a broker dealer and receive commissions for
        sales of the debt securities in the offerings. Only “accredited investors”, as such term is
        defined in Rule 501 of Regulation D of the Act, may invest in the Private Placement Offering
        or the Adamantium Offering. Participation in any of the offerings is subject to certain
        criteria, including meeting financial suitability requirements. Before investing, investors
        should read all of the offering documentation for the relevant offering, including, the
        prospectus for the Registered Offering, and all documents Phoenix Energy has filed with the
        SEC, which you may get for free by visiting EDGAR on the SEC’s website at
        <a
          class="font-inter text-xxs font-medium text-blue-600"
          href="https://www.sec.gov/"
          target="_blank"
          rel="noopener noreferrer"
          >sec.gov</a
        >. Alternatively, Phoenix Energy can arrange to send you any applicable offering documents
        you request at
        <a
          target="_blank"
          rel="noopener noreferrer"
          class="font-inter text-xxs font-medium text-blue-600"
          href="https://phoenixenergy.com/offerings/"
          >phxoffering.com</a
        >. The debt securities offered by Phoenix Energy and Adamantium Capital are speculative,
        unsecured, illiquid, and you may lose some or all of your investment. Past performance is
        not indicative of future results.
      </div>
    </div> -->
    <div
      v-if="isAuthenticatedRoute"
      class="border-[#dfc695] border-t bg-[#f4ebda] dark:bg-[#041626] lg:py-[60px] lg:px-[130px] py-[28px] px-[10px] pb-[80px]"
      ref="disclaimerRef"
    >
      <div class="font-inter text-xs font-bold text-[#75613f] mb-2 dark:text-[#6a7c8c]">
        Important disclosure
      </div>
      <div class="font-inter text-xs font-medium text-stronger mb-6">
        Phoenix Energy One, LLC (“Phoenix Energy”) is conducting offerings of debt securities
        pursuant to (i) an exemption from registration provided by Rule 506(c) of Regulation D (the
        “Private Placement Offering”) of the Securities Act of 1933, as amended (the “Act”) and (ii)
        a registration statement on Form S-1 under the Act (including a prospectus) filed with the
        Securities and Exchange Commission (the “SEC”) (the “Registered Offering”). In addition,
        Adamantium Capital, a wholly owned financing subsidiary of Phoenix Energy, is conducting an
        offering of debt securities pursuant to Rule 506(c) of Regulation D of the Act (the
        “Adamantium Offering”) and loans the proceeds of such offering to Phoenix Energy as its
        sponsor. The debt securities are offered through registered broker dealer(s) that are
        members of FINRA/SIPC (<a
          class="font-inter text-xxs font-medium text-blue-600 underline hover:text-blue-800"
          href="https://www.finra.org/"
          target="_blank"
          rel="noopener noreferrer"
          >finra.org</a
        >/<a
          href="https://www.sipc.org/"
          target="_blank"
          rel="noopener noreferrer"
          class="font-inter text-xxs font-medium text-blue-600 underline hover:text-blue-800"
          >sipic.org</a
        >), that are not affiliated with Phoenix Energy, although certain non-executive personnel of
        Phoenix Energy are registered representatives of a broker dealer and receive commissions for
        sales of the debt securities in the offerings. Only “accredited investors”, as such term is
        defined in Rule 501 of Regulation D of the Act, may invest in the Private Placement Offering
        or the Adamantium Offering. Participation in any of the offerings is subject to certain
        criteria, including meeting financial suitability requirements. Before investing, investors
        should read all of the offering documentation for the relevant offering, including, the
        prospectus for the Registered Offering, and all documents Phoenix Energy has filed with the
        SEC, which you may get for free by visiting EDGAR on the SEC’s website at sec.gov.
        Alternatively, Phoenix Energy can arrange to send you any applicable offering documents you
        request at
        <a
          target="_blank"
          rel="noopener noreferrer"
          class="font-inter text-xxs font-medium text-blue-600 underline hover:text-blue-800"
          href="https://phoenixenergy.com/offerings/"
          >phxoffering.com</a
        >.
      </div>
      <div v-if="route.fullPath.includes('select-offering')">
        <div class="font-inter text-xs font-bold text-[#75613f] mb-2 dark:text-[#6a7c8c]">
          Footnotes
        </div>
        <div class="mb-[56px]">
          <ol class="font-inter text-xs font-medium text-stronger">
            <li class="font-inter text-xs font-medium text-stronger">
              1. Actual maturity term of the Notes is 10 years from issuance. “Short-term” in this
              context refers to the Set Put Interval — the 3-, 6-, 9-,12-, or 18-month interval
              selected between penalty-free redemption options at the time the Notes are purchased.
              See prospectus for additional information.
            </li>
            <li class="font-inter text-xs font-medium text-stronger">
              2. Set Put Interval ("redemption interval") refers to the 3-, 6-, 9-, 12-, or 18-month
              interval selected between penalty-free redemption options when the Notes are
              purchased. The Set Put Date is the last day of each Set Put Interval, with a
              reasonable expectation of the same in the current year. A request for redemption at a
              Set Put Date must be submitted within the required notice window. If Phoenix Energy
              does not receive a valid redemption request by the applicable deadline, Phoenix Energy
              will be under no obligation to redeem the Notes on the next Set Put Date, and the
              Notes will continue. Participants who miss the window can request early redemption,
              which is separate from scheduled penalty-free redemption at a Set Put Date. Early
              redemption may be made at 95% of the aggregate principal amount of the Notes plus
              accrued and unpaid interest, subject to the terms, conditions, exceptions, annual
              limits, and other limitations described in the applicable prospectus and offering
              documents. Phoenix Energy may not be able to satisfy early redemption requests in all
              circumstances. Please see “Risk Factors” in the prospectus for additional information.
            </li>
            <li class="font-inter text-xs font-medium text-stronger">
              3. Registered offerings will be subject to certain criteria, including objective
              financial suitability standards specific to each offerings and amount invested (see
              prospectus). Private placement offerings open to "accredited investors" only.
              Accredited investors as defined in Rule 501 of Regulation D includes individuals with
              a net worth over $1 million (excluding primary residence) or income over $200,000
              (individual) or $300,000 (household) in each of the prior two years, with a reasonable
              expectation of the same in the current year.
              <a
                target="_blank"
                rel="noopener noreferrer"
                class="underline font-inter text-xs"
                href="https://phoenixenergy.com/accreditation/"
                >Learn more about accreditation requirements.</a
              >
            </li>
          </ol>
        </div>
      </div>

      <div class="w-full flex justify-between items-center mb-[10px]">
        <div>
          <img
            :src="UIStore.is_dark_mode ? PHXLogo_Dark : PHXLogo_Light"
            alt="Bird Logo"
            class="mx-auto w-[88px] h-[28px]"
          />
        </div>
        <div class="font-inter text-xs font-medium text-[#8c8c8c]">
          © 2026 Phoenix Energy One, LLC. All rights reserved.
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { onBeforeMount, onMounted, onBeforeUnmount, watch, computed, ref, nextTick } from "vue";
import { RouterView, useRoute, useRouter } from "vue-router";

import {
  useUIStore,
  useAuthStore,
  useDataStore,
  usePurchaseFlowStore,
  useCrudStore,
} from "@/stores";
import { TopNavigation, Notification, LoadingSpinner } from "@/components";
import { setPostHogTheme } from "@/composables/usePostHog";
import PurchaseFlowTopNavigation from "./pages/PurchaseFlow/PurchaseFlowUtilities/PurchaseFlowTopNavigation.vue";
import { useAnalytics, buildInvestorProfile } from "@/composables/useAnalytics";
import PHXLogo_Light from "./assets/images/phx_logo_black_text.png";
import PHXLogo_Dark from "./assets/images/phx_logo_white_text.png";

const route = useRoute();
const router = useRouter();

const { identifyContact, setInvestorProfile } = useAnalytics();

const UIStore = useUIStore();
const authStore = useAuthStore();
const dataStore = useDataStore();
const purchaseFlowStore = usePurchaseFlowStore();
const crudStore = useCrudStore();

const isMaintenanceMode = import.meta.env.VITE_MAINTANENCE_MODE == "true";
const isAuthenticatedRoute = computed(() => route.meta.requires_auth && authStore.is_verified);

const usePurchaseFlowNav = computed(() => {
  return (
    (route.path.startsWith("/make-an-investment") && purchaseFlowStore.current_step > 0) ||
    route.path.startsWith("/change-investment") ||
    route.path === "/thank-you"
  );
});

const disclaimerRef = ref(null);
const disclaimerHeight = ref(0);

const updateDisclaimerHeight = async () => {
  await nextTick();
  disclaimerHeight.value = isAuthenticatedRoute.value ? disclaimerRef.value?.offsetHeight || 0 : 0;
};

const containerStyle = computed(() => {
  return {
    minHeight: isAuthenticatedRoute.value ? `calc(100vh + ${disclaimerHeight.value}px)` : "100vh",
  };
});

onMounted(() => {
  updateDisclaimerHeight();
  window.addEventListener("resize", updateDisclaimerHeight);
});

watch(
  [isAuthenticatedRoute, () => route.path],
  ([isAuth, currentPath], [, prevPath]) => {
    if (isAuth) {
      // TextMagic 403s on /thank-you — skip injection there entirely
      if (currentPath === "/thank-you") return;

      const existing = document.querySelector(
        'script[data-code="ea6c16ef-7753-4efd-b517-f72aa45268db"]'
      );
      const widgetMounted = !!document.getElementById("textmagic-widget");
      // Only skip reinit if the script loaded AND the widget actually rendered.
      // If the script is present but the widget div is missing, a previous init
      // failed (e.g. TextMagic 403'd on the prior URL) — fall through to reinit.
      if (existing && widgetMounted && prevPath !== "/thank-you") return;
      existing?.remove();
      document.getElementById("textmagic-widget")?.remove();

      const script = document.createElement("script");
      script.src = "https://widgets.textmagic.com/messenger-widget-script.js";
      script.setAttribute("data-code", "ea6c16ef-7753-4efd-b517-f72aa45268db");
      script.setAttribute("data-wrapper-id", "textmagic-widget");
      document.head.appendChild(script);
    } else {
      document.querySelector('script[data-code="ea6c16ef-7753-4efd-b517-f72aa45268db"]')?.remove();
      document.getElementById("textmagic-widget")?.remove();
    }
  },
  { immediate: true }
);

onBeforeUnmount(() => {
  window.removeEventListener("resize", updateDisclaimerHeight);
});

watch(isAuthenticatedRoute, () => {
  updateDisclaimerHeight();
});

watch(
  () => route.fullPath,
  () => {
    updateDisclaimerHeight();
  }
);

onBeforeMount(async () => {
  try {
    if (localStorage.getItem("current_user")) {
      authStore.current_user = JSON.parse(localStorage.getItem("current_user"));
      authStore.is_verified = true;
      await dataStore.setData();
      identifyContact(dataStore.contact);
      setInvestorProfile(buildInvestorProfile(dataStore.contact, dataStore.investments, "sign_in"));
    } else {
      authStore.is_verified = false;
      authStore.current_user = null;
    }

    if (localStorage.getItem("is_dark_mode")) {
      UIStore.is_dark_mode = localStorage.getItem("is_dark_mode") === "true";
    }

    // Detect marketing params and enable dark mode
    const urlParams = new URLSearchParams(window.location.search);
    const darkModeParams = [
      "utm_campaign",
      "utm_medium",
      "utm_source",
      "utm_term",
      "utm_content",
      "gad_source",
      "gad_campaignid",
      "gbraid",
      "gclid",
      "_gl",
    ];

    if (darkModeParams.some((param) => urlParams.has(param))) {
      UIStore.is_dark_mode = true;
    }

    UIStore.setupAlertWatcher();
  } catch (err) {
    console.error(err);
  }
});

watch(
  usePurchaseFlowNav,
  (active) => {
    document.body.classList.toggle("purchase-flow-active", active);
  },
  { immediate: true }
);

const hasStaticBottomBar = computed(() =>
  ["/portfolio", "/investment-details", "/documents", "/profile"].includes(route.path)
);

watch(
  hasStaticBottomBar,
  (active) => {
    document.body.classList.toggle("mobile-bottom-bar-active", active);
  },
  { immediate: true }
);

const purchaseFlowMetricsActive = computed(
  () => usePurchaseFlowNav.value && purchaseFlowStore.current_step >= 3
);

watch(
  purchaseFlowMetricsActive,
  (active) => {
    document.body.classList.toggle("purchase-flow-metrics-active", active);
  },
  { immediate: true }
);

watch(
  () => UIStore.is_dark_mode,
  async (isDark) => {
    localStorage.setItem("is_dark_mode", isDark ? "true" : "false");
    document.documentElement.classList.toggle("dark", isDark);

    // Update Safari's theme-color for status bar / overscroll
    const themeColor = isDark ? "#012e40" : "#fffaf0";
    document.querySelectorAll('meta[name="theme-color"]').forEach((el) => el.remove());
    const meta = document.createElement("meta");
    meta.name = "theme-color";
    meta.content = themeColor;
    document.head.appendChild(meta);

    await nextTick();
    window.scrollTo(0, window.scrollY + 1);
    requestAnimationFrame(() => {
      window.scrollTo(0, window.scrollY - 1);
    });

    if (dataStore.contact) {
      let log = {
        step: "UI Theme Changed",
        substep: `Changed to ${isDark ? "Dark" : "Light"} Mode`,
        status: `${isDark ? "Dark" : "Light"} Mode`,
        message: `Changed to ${isDark ? "Dark" : "Light"} Mode`,
        url: "",
      };

      log = dataStore.setDefaultFields(log, "investoractivity");
      crudStore.insert("investoractivity", [log]);
    }

    setPostHogTheme(isDark ? { theme: "dark" } : { theme: "light" });
  },
  { immediate: true }
);

watch(
  () => authStore.invalid_session,
  () => {
    if (authStore.invalid_session) {
      authStore.resetApplication();
      router.push("/sign-in");
    }
  }
);

watch(
  () => route.fullPath,
  async () => {
    if (dataStore.contact) {
      let page = "Unknown";

      switch (route.path) {
        case "/dashboard":
          page = "Dashboard";
          break;
        case "/profile":
          page = "Profile";
          break;
        case "/make-an-investment":
          page = "Purchase Flow";
          break;
        case "/documents":
          page = "Documents";
          break;
        case "/portfolio":
          page = "Portfolio";
          break;
        case "/newsfeed":
          page = "News Feed";
          break;
        case "/thank-you": {
          let investment_id = route.query.investment_id;
          page =
            "Thank You - " +
            (investment_id ? `Investment ID: ${investment_id}` : "Unknown Investment ID");
          break;
        }
        case "/investment-details": {
          let record_id = route.query.recordId;
          page = `Investment Details - ${record_id ? record_id : "Unknown Record ID"}`;
          break;
        }
        case "/change-investment": {
          let change_investment_id = route.query.investment_id;
          page = `Change Investment - ${change_investment_id ? change_investment_id : "Unknown Investment ID"}`;
          break;
        }
        case "/contact-us": {
          page = "Contact Us Form";
          break;
        }
        default:
          break;
      }

      let log = {
        step: page,
        substep: "",
        status: "Navigated",
        message: `${page}`,
        url: route.fullPath,
        investment_id: route.query.investment_id
          ? route.query.investment_id
          : purchaseFlowStore.current_investment?.record_id
            ? purchaseFlowStore.current_investment.record_id
            : null,
        session_id: authStore.current_user?.session_id || null,
      };

      log = dataStore.setDefaultFields(log, "investoractivity");
      crudStore.insert("investoractivity", [log]);
    }
  }
);
</script>
